import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { QUERY_KEYS, QUERY_STALE_TIMES } from '@/lib/constants';

interface UseReportOptions {
  from: string;
  to: string;
  enabled?: boolean;
}

export function useReport(options: UseReportOptions) {
  const { from, to, enabled = true } = options;

  return useQuery({
    queryKey: [QUERY_KEYS.reports, from, to],
    queryFn: () => api.getReport(from, to),
    enabled: enabled && !!from && !!to,
    staleTime: QUERY_STALE_TIMES.reports,
  });
}
